import Vue from 'vue'
import VueI18n from 'vue-i18n'
import customZhCn from './lang/zh_CN'
import customZhHK from './lang/zh_HK'
import customEnUs from './lang/en_US'
import customInrID from './lang/in_rID'
Vue.use(VueI18n)

const lang = 'en-US'

const browserLanguage = navigator.language || navigator.userLanguage

// vue-i18n 6.x+写法
Vue.locale = () => {}
const messages = {
  'zh-CN': customZhCn,
  'zh-HK': customZhHK,
  'en-US': customEnUs,
  'in-rID': customInrID
}
// 通过浏览器语言设置默认语言
const defaultLanguage = browserLanguage in messages ? browserLanguage : lang

Vue.config.lang = defaultLanguage
const i18n = new VueI18n({
  locale: defaultLanguage,
  messages
})

export default i18n
